import {$_TYPE} from "@/confs/common.const";

export default {
    toDict(list, keyPropNm) {
        let dataMap = {};
        if(typeof list !== 'undefined') {
            list.forEach(function(data) {
                let keyValue = "";
                if(typeof keyPropNm === 'function') {
                    keyValue = keyPropNm(data);
                } else {
                    keyValue = data[keyPropNm];
                }

                if(typeof data !== 'undefined' && typeof keyValue !== 'undefined') {
                    dataMap[keyValue] = data;
                }
            });
        }

        return dataMap;
    },
    toMap(list, keyPropNm) {
        let dataMap = {};
        if(typeof list !== 'undefined') {
            list.forEach(function(data) {
                let keyValue = "";
                if(typeof keyPropNm === 'function') {
                    keyValue = keyPropNm(data);
                } else {
                    keyValue = data[keyPropNm];
                }

                if(typeof data !== 'undefined' && typeof keyValue !== 'undefined') {
                    if(typeof dataMap[keyValue] === 'undefined') {
                        dataMap[keyValue] = [];
                    }
                    dataMap[keyValue].push(data);
                }
            });
        }

        return dataMap;
    },
    toList(map) {
        let list = [];
        for (const [key, entry] of Object.entries(map)) {
            if(Array.isArray(entry)) {
                entry.forEach(d => {
                    list.push(d);
                });
            } else {
                list.push(entry);
            }
        }
        return list;
    },
    toReplaceList(list, valSeq, oldVal, newVal) {
        list.forEach(d => {
            if(d[valSeq] === oldVal){
                d[valSeq] = newVal;
            }
        });
        return list;
    },
    toCurrency(val) {
        if(typeof val !== 'undefined') {
            return Math.round(val).toLocaleString();
        } else {
            return '';
        }
    },
    separateCurrencyUnit(number) {
        let  inputNumber  = number < 0 ? false : number;
        let  unitWords    = ['일', '만', '억', '조', '경'];
        let  splitUnit    = 10000;
        let  splitCount   = unitWords.length;
        let  resultArray  = [];
        let  result = {'일': 0, '만': 0, '억': 0, '조': 0, '경': 0};

        for (let  i = 0; i < splitCount; i++){
            let  unitResult = (inputNumber % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
            unitResult = Math.floor(unitResult);
            if (unitResult > 0){
                resultArray[i] = unitResult;
            }
        }

        for (let  i = 0; i < resultArray.length; i++){
            if(!resultArray[i]) continue;
            result[unitWords[i]] = resultArray[i];
        }

        return result;
    },
    // 억단위까지만 단위 붙히기
    addCurrencyUnit(number) {
        let result = "";
			let num = number.toString();
			for(let i=0; i<num.length; i++) {
				let str = num.charAt(num.length-(i+1));
				if(i === 4) str += "만";
				if(i === 8) str += "억";
				if(i === 12) str += "조";
				result = str + result;
			}
			let total = result.split('억');
			return total[0] + '억' ;
    },
    // 문자열 Date형으로 변환
    stringToDate(val) {
        let baseDay = val || '';
        let dayStr = '';

        if(baseDay !== '') {
            baseDay = baseDay.replace(/-/gi, "");
            baseDay = baseDay.replace(/:/gi, "");
            baseDay = baseDay.replace(/ /gi, "");
            baseDay = baseDay.replace(/\./gi, "");
        }

        if(baseDay.length >= 8) {
            let date = new Date();

            let y = baseDay.substring(0, 4);
            let m = baseDay.substring(4, 6);
            let d = baseDay.substring(6, 8);

            date.setFullYear(y);
            date.setMonth(m- 1, d);

            if(baseDay.length >= 10) {
                let h = baseDay.substring(8, 10);
                date.setHours(h);
            }

            if(baseDay.length >= 12) {
                let min = baseDay.substring(10, 12);
                date.setMinutes(min);
            }

            if(baseDay.length >= 14) {
                let sec = baseDay.substring(12, 14);
                date.setSeconds(sec);
            }

            return date;
        } else {
            return "";
        }
    },
    formatDate(val, f, defaultStr) {
        if(typeof defaultStr === 'undefined' || defaultStr == null) {
            defaultStr = "";
        }

        if(typeof val === 'undefined') {
            return defaultStr;
        }

        let date = this.stringToDate(val);
        if(typeof date !== $_TYPE.UNDEF && date !== '') {
            return date.format(f)
        } else {
            return defaultStr;
        }
    },
    diffDay(fromDate, toDate) {
        let diffDate1 = fromDate instanceof Date ? fromDate :new Date(fromDate);
        let diffDate2 = toDate instanceof Date ? toDate :new Date(toDate);

        diffDate1 =new Date(diffDate1.getFullYear(), diffDate1.getMonth() + 1, diffDate1.getDate());
        diffDate2 =new Date(diffDate2.getFullYear(), diffDate2.getMonth() + 1, diffDate2.getDate());

        let diff = Math.abs(diffDate2.getTime() - diffDate1.getTime());
        diff = Math.ceil(diff / (1000 * 3600 * 24));

        return diff;
    },
    // 문자열 byte로 자르기
    cutStrByte(str, limit, addStr) {
        let strLength = 0;
        let strTitle = "";
        let strPiece = "";
        addStr = typeof addStr !== $_TYPE.UNDEF ? addStr : "";

        for (let i = 0; i < str.length; i++){
            let code = str.charCodeAt(i);
            let ch = str.substr(i,1).toUpperCase();
            //체크 하는 문자를 저장
            strPiece = str.substr(i,1);
            code = parseInt(code);

            if ((ch < "0" || ch > "9") && (ch < "A" || ch > "Z") && ((code > 255) || (code < 0))){
                strLength = strLength + 3; //UTF-8 3byte 로 계산
            }else{
                strLength = strLength + 1;
            }

            if(strLength>limit){ //제한 길이 확인
                break;
            }else{
                strTitle = strTitle + strPiece; //제한길이 보다 작으면 자른 문자를 붙여준다.
            }
        }

        if(strTitle.length < str.length) {
            strTitle += addStr;
        }

        return strTitle;
    },
    // 문자열 길이로 자르기
    cutStrLength(str, len, addStr) {
        if(!str) {
            return "";
        }

        if(str.length <= len) {
            return str;
        }

        let returnStr = str.substr(0, len);
        if(addStr) {
            returnStr += addStr;
        }

        return returnStr;
    },
    // 깊은 복사
    cloneObject(obj) {
        let clone = [];
        for (let key in obj) {
          if (typeof obj[key] == "object" && obj[key] != null) {
            clone[key] = this.cloneObject(obj[key]);
          } else {
            clone[key] = obj[key];
          }
        }

        return clone;
    },
    // 숫자 추출
    extractNumber(str){
        let res = str.replace(/[^0-9]/g,"");
        return res;
    },
}
